<template>

  <section class="home-main-section">
		<img src="../../../assets/homepageVector.png" style="position: absolute;left: 168px;bottom: -29px;z-index:10" id="lingoVector" class="hidden-md-and-down"/>
		<img src="../../../assets/homepageVector2.png" style="position: absolute;left: 335px;bottom: 1000px;z-index: 10;" id="lingoVector2" class="hidden-md-and-down"/>
		<img src="../../../assets/note1.png" style="position: absolute;left: 273px;top: 173px;z-index: 1; animation: note-ani 5s infinite" id="note1" class="hidden-md-and-down"/>
		<img src="../../../assets/note1.png" style="position: absolute;left: 604px;top: 168px;z-index: 1; animation: note-ani 3s infinite" id="note2" class="hidden-md-and-down"/>
		<img src="../../../assets/note1.png" style="position: absolute;left: 461px;top: 189px;z-index: 1; animation: note-ani 8s infinite" id="note3" class="hidden-md-and-down"/>
		<img src="../../../assets/hand.png" style="position: absolute;right: -200px;top: 189px;z-index: 1; animation: none;z-index:100" id="hand" class="hidden-md-and-down"/>
		<img src="../../../assets/city.png" style="position: absolute;left: -12px;bottom:0px;z-index: 8;opacity: 0.3;" id="city" class="hidden-md-and-down"/>
		<img src="../../../assets/cloud.png" style="position: absolute;opacity: 0.4;left: -360px;top: 10px;z-index: 11;animation: 50s ease 0s infinite normal none running cloud-ani;transform: scale(0.6);" id="cloud" class="hidden-sm-and-down"/>
		<img src="../../../assets/cloud2.png" style="position: absolute;opacity: 0.2;right: -360px;top: 30px;z-index: 8;animation: 50s ease 0s infinite normal none running cloud2-ani;transform: scale(0.7);" id="cloud2" class="hidden-sm-and-down"/>

			<!-- https://www.simbula.eu/en/european-funds-2018-bg16rfop002-2-024/-->
			<header class="euFundHeader">
				This web site is funded by procedure BG16RFOP002-2.024 - Promotion of Entrepreneurship, Operational Programme "Innovations and Competitiveness" 2014 - 2020, co-funded by European Union - European Regional Development Fund, Project BG16RFOP002-2.024-0259 -
				"Promotion of enterpreneurship in Lingo AV by development of Text-to-Speech content delivery platform for TV and film industry".
				<router-link to="/programInfo" style="color:#efe731">Project Details</router-link>
			</header>
			<v-toolbar class="transparent elevation-0">
					
					<a href="/">
						<img src="../../../assets/lingoLogo.png" style="position: relative;top: 3px;transform: scale(0.3);left: -61px;opacity: 0.8;" class="mainLogo" />
					</a>
						<img src="../../../assets/logoTitleWhite.png" style="left: -104px;top: 4px;position: relative;" class="hidden-sm-and-down"/>
					<v-spacer></v-spacer>

					<v-toolbar-items class="hidden-sm-and-down">
						<v-btn flat class="font-weight-medium toolbar-link" color="rgb(239, 231, 49)" to="/app/gallery">Try it freely</v-btn>
						<v-btn flat class="font-weight-medium toolbar-link" color="white" href="#pricing-section">Pricing</v-btn>
						<v-btn flat class="font-weight-medium toolbar-link" color="white" @click='login()'>Sign In</v-btn>
					</v-toolbar-items>

					<v-toolbar-items class="hidden-md-and-up">
						<v-menu offset-y style="position:relative;z-index:100">
     						<v-btn slot="activator" color="white" icon flat>
        						<v-icon>menu</v-icon>
      						</v-btn>
      						<v-list>
        						<v-list-tile to='/app/gallery'>
          							<v-list-tile-title>Try It Freely</v-list-tile-title>
        						</v-list-tile>
        						<v-list-tile href="#pricing-section">
          							<v-list-tile-title>Pricing</v-list-tile-title>
        						</v-list-tile>
        						<v-list-tile @click='login()'>
          							<v-list-tile-title>Sign In</v-list-tile-title>
        						</v-list-tile>
      						</v-list>
    					</v-menu>
					</v-toolbar-items>
				</v-toolbar>


				<v-layout row align-center justify-center class="white--text relative" style="z-index: 15;">
					<v-flex md0 lg6></v-flex>

					<v-flex md12 lg6 style="padding:2rem">
						<div class="subhead font-weight-light">
						<h1 class="mb-3 font-weight-regular">Hello, we are Lingo AV</h1>
						<!--<span style="color:rgb(173, 255, 214)">-->
							We provide voice audio for your text in any language,
						  at speed and price that are impossible to be matched by a flesh-and-blood voice character.
							We leverage most advanced synthetic voice generators whose voice qualities are almost
							identical to the humans' and continuously improve over time.
						</div>

						<v-btn class="white black--text mt-5 mr-3 elevation-0" style="margin:0px;box-shadow:-1px 0px 17px -3px rgb(160,160,160) !important;font-weight: 600;font-size: 1.1rem;"
							dark large @click='login()' @mouseover="getStartedMouseOver" @mouseleave="getStartedMouseOut">Get Started for Free</v-btn>
						<v-btn class="mt-5 black--text elevation-0" style="margin:0px;box-shadow:-1px 0px 17px -3px rgb(160,160,160) !important;font-weight: 600;font-size: 1.1rem;" dark large to="/app/gallery" color="#efe731">Browse Demo Voices</v-btn>
					</v-flex>

				</v-layout>

		</section>



</template>

<style>

@media (max-width: 1380px) {
	#lingoVector {
		left:20px !important;
	}
}

@media (min-width: 1264px) {
	.subhead {
		padding-right:12rem;
		padding-top:5vh !important;
	}
	.home-main-section {
		min-height:70vh;
	}
}


@keyframes note-ani {
  0% {
    opacity: 0;
    transform:scale(0.6);
  }
  50% {
    opacity: 1;
    transform:scale(1.2);
  }
  100% {
    opacity: 0;
    transform:scale(0.7);
  }
}

@keyframes cloud-ani {
  0% {
    left:-360px;
    transform:scale(0.7);
    opacity: 0.4;
  }
  60% {
    transform:scale(0.4);
    opacity: 0.3;
  }
  100% {
    left:2000px;
    transform:scale(0.2);
    opacity: 0.2;
  }
}

@keyframes cloud2-ani {
  0% {
    right:-360px;
    transform:scale(0.1);
  }
  60% {
    transform:scale(0.3);
  }
  100% {
    right:2000px;
    transform:scale(0.5);
  }
}

@keyframes hand-ani {
  0% {
    transform: rotate(0deg);
  }
  60% {
    transform: rotate(-10deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

.toolbar-link {
	font-size:1.2rem;
}

#lingoVector2 {
	transition: all 2s;
}


#lingoVector, #hand, #city {
	transition: all 0.5s;
}

.home-main-section:hover #city {
	left: -25px !important;
}

.home-main-section:hover #lingoVector {
	transform: scale(1.06);
}

.home-main-section:hover #lingoVector2 {
	bottom: 300px !important;
	transition: all 0.6s;
}

.home-main-section:hover .mainLogo {
	bottom: 300px !important;
	transform: scale(0.4) !important;
	transition:transform 10s;

}

.hand-active {
	right: -19px !important;
	animation: hand-ani 4s infinite !important;
}


.home-main-section {
	--background-color: #4d1d85;
    --background-image: linear-gradient(to bottom, #200e35, #4d1d85);
    -background: #4d1d85;
    -background: linear-gradient(-11deg, #128e2f, #77c609);
    --background:linear-gradient(3deg, rgb(98, 231, 183), rgb(9, 194, 160), rgba(15, 171, 162, 0.95));
    -background:linear-gradient(-11deg, rgba(8, 152, 107, 0.95), rgba(20, 187, 134, 0.95));
    --background:radial-gradient(ellipse at bottom, #0fc80f 0%, #18860b 100%);
    -background:radial-gradient(ellipse at bottom, green 0%, #090A0F 100%);
     background:radial-gradient(ellipse at bottom, #4ad896 0%, #0b8649 100%);
    --min-height:520px;
    --height:70vh;
    position:relative;
    --overflow:hidden;
    }

.subhead {
		font-size:1.6rem;
		color:white;
		padding-top:0.5rem;
	}

.euFundHeader {
	background: #097541;
    color: #def9ec;
    padding: 0.8rem 0.5rem;
   	font-size: 1rem;
    line-height: 1.3rem;
    font-family: Arial;
}

.mainLogo{
	transition:transform 5s;
}


</style>

<script>
import {Auth} from '../auth/cognito_auth';

export default {
  name: "main_section",
  data() {
    return {
    };
  },
  methods: {
  		getStartedMouseOver : function() {
			this.in('hand', 'hand-active');
		},

		getStartedMouseOut : function() {
			this.out('hand', 'hand-active');
		},
		in : function(id, cls) {
			document.getElementById(id).classList.add(cls);
		},
		out : function(id, cls) {
			document.getElementById(id).classList.remove(cls);
		},
		login : function() {
				Auth.login();
		}
  }
};
</script>
